import { BASE_MODELS } from "./baseModels";
import { MODELS_BY_COUNTRY } from "./modelsByCountry";
import { COUNTRY_CODES } from "../../constants/countries";

export const getModels = (country) => {
    const rules = MODELS_BY_COUNTRY[country?.code] || MODELS_BY_COUNTRY[COUNTRY_CODES.ECUADOR];

    const { hide = [], include = [] } = rules;

    const filtered = BASE_MODELS.filter(model => !hide.includes(model.key));
    const extended = [...filtered, ...include];

    return extended;
};
